var render = function render(){
  var _vm$error, _vm$error$validationM, _vm$error2, _vm$error2$validation, _vm$error3, _vm$error3$validation, _vm$error4, _vm$error4$validation, _vm$error5, _vm$error5$validation;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key)) + " ")]) : _vm._e(), _c('b-form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-last-name",
      "label": _vm.$t('signup.form.last-name'),
      "required": "",
      "state": _vm.getState('lastName'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM = _vm$error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.lastName,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.lastName.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.last-name')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.lastName.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.last-name'),
          max: _vm.$v.formData.lastName.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.lastName.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.lastName, "$model", $$v);
      },
      expression: "$v.formData.lastName.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-first-name",
      "label": _vm.$t('signup.form.first-name'),
      "required": "",
      "state": _vm.getState('firstName'),
      "validation-messages": (_vm$error2 = _vm.error) === null || _vm$error2 === void 0 ? void 0 : (_vm$error2$validation = _vm$error2.validationMessages) === null || _vm$error2$validation === void 0 ? void 0 : _vm$error2$validation.firstName,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.firstName.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.first-name')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.firstName.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.first-name'),
          max: _vm.$v.formData.firstName.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.firstName.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.firstName, "$model", $$v);
      },
      expression: "$v.formData.firstName.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-email",
      "label": _vm.$t('signup.form.email'),
      "required": "",
      "state": _vm.getState('email'),
      "validation-messages": (_vm$error3 = _vm.error) === null || _vm$error3 === void 0 ? void 0 : (_vm$error3$validation = _vm$error3.validationMessages) === null || _vm$error3$validation === void 0 ? void 0 : _vm$error3$validation.email,
      "type": "email"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.email.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.email')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.email.email ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.email')) + " ")]) : _vm._e(), !_vm.$v.formData.email.localPartMaxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.email')) + " ")]) : _vm._e(), !_vm.$v.formData.email.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.email'),
          max: _vm.$v.formData.email.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.email.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.email, "$model", $$v);
      },
      expression: "$v.formData.email.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-phone",
      "label": _vm.$t('signup.form.phone'),
      "required": "",
      "state": _vm.getState('phone'),
      "validation-messages": (_vm$error4 = _vm.error) === null || _vm$error4 === void 0 ? void 0 : (_vm$error4$validation = _vm$error4.validationMessages) === null || _vm$error4$validation === void 0 ? void 0 : _vm$error4$validation.phone,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.phone.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.phone')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.minLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.min-length', {
          field: _vm.$t('signup.form.phone'),
          min: _vm.$v.formData.phone.$params.minLength.min
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.phone'),
          max: _vm.$v.formData.phone.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.phoneNumber ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.phone')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.phone.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.phone, "$model", $$v);
      },
      expression: "$v.formData.phone.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-password",
      "label": _vm.$t('signup.form.password'),
      "required": "",
      "state": _vm.getState('password'),
      "validation-messages": (_vm$error5 = _vm.error) === null || _vm$error5 === void 0 ? void 0 : (_vm$error5$validation = _vm$error5.validationMessages) === null || _vm$error5$validation === void 0 ? void 0 : _vm$error5$validation.password,
      "type": "password"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.password.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.password')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('signup.form.password'),
          max: _vm.$v.formData.password.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.minLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.min-length', {
          field: _vm.$t('signup.form.password'),
          min: _vm.$v.formData.password.$params.minLength.min
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.uppercase ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.uppercase')) + " ")]) : _vm._e(), !_vm.$v.formData.password.digit ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.digit')) + " ")]) : _vm._e(), !_vm.$v.formData.password.special ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.special')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.password.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.password, "$model", $$v);
      },
      expression: "$v.formData.password.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "signup-password-again",
      "label": _vm.$t('signup.form.password-again'),
      "required": "",
      "state": _vm.getState('passwordAgain'),
      "type": "password"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.passwordAgain.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('signup.form.password-again')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.passwordAgain.sameAs ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.same-as')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.passwordAgain.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.passwordAgain, "$model", $$v);
      },
      expression: "$v.formData.passwordAgain.$model"
    }
  })], 1)], 1), _vm.showLegalConsents ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-form-checkbox', {
    staticClass: "legal-consent",
    attrs: {
      "id": "signup-accepted-terms",
      "value": true,
      "unchecked-value": false,
      "state": _vm.getState('acceptedTerms')
    },
    model: {
      value: _vm.$v.formData.acceptedTerms.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.acceptedTerms, "$model", $$v);
      },
      expression: "$v.formData.acceptedTerms.$model"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('signup.form.accept-terms-prefix')) + " "), _c('a', {
    staticClass: "legal-link",
    attrs: {
      "href": _vm.termsAndConditionsLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.form.terms-and-conditions')) + " ")]), _vm._v(" " + _vm._s(_vm.$t('signup.form.accept-terms-suffix')) + " ")])]), _vm.submitted && !_vm.$v.formData.acceptedTerms.accepted ? _c('b-form-invalid-feedback', {
    staticClass: "d-block"
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.validation.accepted-terms-required')) + " ")]) : _vm._e(), _vm._l(_vm.getValidationMessages('acceptedTerms'), function (message, index) {
    return _c('b-form-invalid-feedback', {
      key: `accepted-terms-validation-${index}`,
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(_vm.$t(message)) + " ")]);
  }), _c('b-form-checkbox', {
    staticClass: "legal-consent",
    attrs: {
      "id": "signup-accepted-privacy-policy",
      "value": true,
      "unchecked-value": false,
      "state": _vm.getState('acceptedPrivacyPolicy')
    },
    model: {
      value: _vm.$v.formData.acceptedPrivacyPolicy.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.acceptedPrivacyPolicy, "$model", $$v);
      },
      expression: "$v.formData.acceptedPrivacyPolicy.$model"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('signup.form.accept-privacy-prefix')) + " "), _c('a', {
    staticClass: "legal-link",
    attrs: {
      "href": _vm.privacyPolicyLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.form.privacy-policy')) + " ")]), _vm._v(" " + _vm._s(_vm.$t('signup.form.accept-privacy-suffix')) + " ")])]), _vm.submitted && !_vm.$v.formData.acceptedPrivacyPolicy.accepted ? _c('b-form-invalid-feedback', {
    staticClass: "d-block"
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.validation.accepted-privacy-policy-required')) + " ")]) : _vm._e(), _vm._l(_vm.getValidationMessages('acceptedPrivacyPolicy'), function (message, index) {
    return _c('b-form-invalid-feedback', {
      key: `accepted-privacy-policy-validation-${index}`,
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(_vm.$t(message)) + " ")]);
  })], 2) : _vm._e(), _c('b-row', {
    staticClass: "mt-4",
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', [_c('b-button', {
    staticClass: "btn-submit w-100 mb-3",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": !_vm.$v.formData.$anyDirty
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.button.submit')) + " ")])], 1)], 1), _c('b-row', [_c('b-col', [_vm._t("back")], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }